import * as yup from 'yup';
import { IFileDataBase64 } from "../../interface/fileDataBase64.interface"
import { FILE_TOO_LARGE_PATH, FILE_UNSUPPORTED_FORMAT_PATH, MAX_FILE_SIZE,
     REQUIRED_FIELD_PATH, SUPPORTED_FORMATS } from "../errorMessages"


export const addFileSchema = yup.object().shape({
    value: yup.mixed()
        .nonNullable()
        .required(REQUIRED_FIELD_PATH)
        .test(
            "FILE_SIZE",
            FILE_TOO_LARGE_PATH,
            (value: IFileDataBase64) => {

                return !value || (value && value.size <= MAX_FILE_SIZE)
            }
        ).test(
            "FILE_FORMAT",
            FILE_UNSUPPORTED_FORMAT_PATH,
            (value: IFileDataBase64) => {

                return !value || (value && SUPPORTED_FORMATS.includes(value?.contentType))
            }
        ),
})

